import { Component, Input, OnInit } from '@angular/core';
import { Headers } from '@angular/http';
import { ApiService, CacheService, Country, LoggedUser, MiscConfig } from 'angular-lib';
import { CompleterItem, CompleterService, RemoteData } from 'ng2-completer';
import * as moment from 'moment';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs/Observable';
import { LoaderService } from '../../../services/loader.service';
import { Subject } from 'rxjs/Subject';

@Component({
    selector: 'ez-edit-profile',
    template: require('./edit-profile.component.html'),
    styles: [require('./edit-profile.component.less')]
})
export class EditProfileComponent implements OnInit {
    public cityRemoteData: RemoteData;
    @Input() public user: LoggedUser;
    public miscConfig: MiscConfig;

    // Error icon
    public errorIconType = {
        success: 'check',
        error: 'delete'
    };

    // Displayname
    public startDisplayName: string = '';
    public displaynameStatusMessage: string = '';
    public displaynameStatusType: string = '';
    public displaynameEditEnabled: boolean = false;

    // Location
    public country: Country;
    public locationName: string;
    public locationId: number;
    public countryId: number;
    public locationStatusMessage: string = '';
    public locationStatusType: string = '';

    // Description
    public description: string = '';
    public descriptionMaxLength: number = 0;
    public descriptionMinLength: number = 0;

    // Born Date
    public formattedDate: string;
    public startFormattedDate: string;
    public maxBornDateFormatted: string;
    public minBornDateFormatted: string;
    public borndateStatusMessage: string = '';
    public borndateStatusType: string = '';
    public borndateEditEnabled: boolean = false;

    // Translation description
    public translationDescriptionKey: string = '';
    public translationDescriptionErrorKey: string = '';
    public translationData = {
        date: '',
    };
    public descriptionStatusType: string = '';

    public enableSubmitButton = {
        location: true,
        displayname: true,
        borndate: true,
        description: true,
    };

    public subs: Array<Observable<any>> = [];
    public subject: Subject<any>;

    constructor(
        private apiService: ApiService,
        private completerService: CompleterService,
        private loaderService: LoaderService
    ) {
    }

    public ngOnInit() {
        this.subject = new Subject<any>();
        this.loaderService.show();

        this.apiService.miscConfig().subscribe(conf => {
            this.miscConfig = conf;
            if (this.miscConfig.description) {
                this.descriptionMaxLength = this.miscConfig.description.maxLength;
                this.descriptionMinLength = this.miscConfig.description.minLength;
            }

            this.apiService.get('/ws/profile/location')
                .subscribe(data => {
                    if (data.country) {
                        this.country = new Country(data.country);
                        this.countryId = this.country.id;
                    }

                    if (data.location) {
                        this.locationId = data.location.id;
                    }

                    this.cityRemoteData = this.completerService.remote(
                        null,
                        null,
                        'value'
                    );

                    this.cityRemoteData.urlFormater(term => {
                        return this.apiService.autocompleteurl + '?q=' + term + '&countryId=' + this.countryId;
                    });

                    this.cityRemoteData.headers(new Headers({
                        Accept: 'application/json',
                        Authorization: 'Bearer ' + localStorage.getItem(environment.tokenName)
                    }));

                    if (data.location) {
                        this.locationName = data.location.name;
                    }

                    this.subject.next();
                    this.subject.complete();
                });
        });

        this.subs.push(this.subject.asObservable());

        // Getting user
        let sessionS = this.apiService.user();
            sessionS.subscribe(user => {
                if (user instanceof LoggedUser) {
                    this.user = user;
                    if (this.user.description !== null) {
                        this.description = this.user.description.text;
                        this.translationDescriptionKey = 'profile.description-' + this.user.description.status;
                        if (this.user.description.moderated_at) {
                            this.translationData.date = moment(this.user.description.moderated_at).format('YYYY-MM-DD');
                        }
                    }

                    this.startDisplayName = this.user.displayname;
                    this.displaynameEditEnabled = this.user.allowToChangeDisplayName;
                    this.borndateEditEnabled = this.user.allowToChangeBornDate;

                    this.startFormattedDate = moment(this.user.bornDate).format('YYYY-MM-DD');
                    this.formattedDate = moment(this.user.bornDate).format('YYYY-MM-DD');

                    let maxBornDate = moment().subtract(18, 'years').toDate();
                    let minBornDate = moment().subtract(100, 'years').toDate();
                    this.maxBornDateFormatted = moment(maxBornDate).format('YYYY-MM-DD');
                    this.minBornDateFormatted = moment(minBornDate).format('YYYY-MM-DD');
                }
        }, error => {
            console.log('error user', error);
        });
        this.subs.push(sessionS);

        Observable.forkJoin(this.subs).subscribe(
            res => {
                this.loaderService.hide();
            },
            error => {
                this.loaderService.hide();
            }
        );
    }

    public citySelected(item: CompleterItem) {
        this.locationId = item.originalObject.id;
    }

    public save() {
        // Prevent multi click on save button
        Object.keys(this.enableSubmitButton).forEach(i => {
            let value = this.enableSubmitButton[i];
            if (value === false) {
                return value;
            }
        });

        // Save displayname
        if (
            this.user.allowToChangeDisplayName
            && this.displaynameEditEnabled
            && this.startDisplayName !== this.user.displayname
        ) {
            let body = JSON.stringify({
                displayname: this.user.displayname
            });

            this.enableSubmitButton.displayname = false;

            this.apiService.post('/ws/profile/displayname', body)
                .subscribe(data => {
                    if (data.usernameUpdated === false) {
                        this.displaynameStatusMessage = data.message;
                        this.displaynameStatusType = 'error';
                    } else {
                        this.displaynameStatusType = 'success';
                        this.displaynameEditEnabled = false;
                    }

                    this.enableSubmitButton.displayname = true;
                });
        }

        // Save borndate
        if (
            this.user.allowToChangeBornDate
            && this.startFormattedDate !== this.formattedDate
            && this.borndateEditEnabled
        ) {
            this.enableSubmitButton.borndate = false;
            let date: string[] = this.formattedDate.split('-');
            let body = JSON.stringify({
                'borndate-year': date[0],
                'borndate-month': date[1],
                'borndate-day': date[2]
            });

            this.apiService.post('/ws/profile/borndate', body)
                .subscribe(data => {
                    this.enableSubmitButton.borndate = true;
                    if (data.hasOwnProperty('message')) {
                        this.borndateStatusMessage = data.message;
                        this.borndateStatusType = 'error';
                    } else {
                        this.borndateStatusType = 'success';
                        this.borndateEditEnabled = false;
                    }
                }, error => {
                    this.borndateStatusMessage = JSON.parse(error.text()).message;
                    this.borndateStatusType = 'error';
                    this.enableSubmitButton.location = true;
                });
        }

        // Save location
        this.enableSubmitButton.location = false;
        this.apiService.saveLocation(this.locationId)
            .subscribe((data) => {
                if (data.hasOwnProperty('location') && data.location === undefined) {
                    this.locationStatusMessage = data.message;
                    this.locationStatusType = 'error';
                } else {
                    this.locationStatusType = 'success';
                }
                this.enableSubmitButton.location = true;
            }, error => {
                this.locationStatusMessage = JSON.parse(error.text()).message;
                this.locationStatusType = 'error';
                this.enableSubmitButton.location = true;
            });

        // Save description
        if (
            this.description !== ''
            && (
                this.user.description === null
                || (this.description !== this.user.description.text)
            )
        ) {
            this.translationDescriptionErrorKey = '';
            if (
                this.description.length > this.descriptionMaxLength
                || this.description.length < this.descriptionMinLength
            ) {
                this.descriptionStatusType = 'error';

                if (this.description.length > this.descriptionMaxLength) {
                    this.translationDescriptionErrorKey = 'profile.description-max-error';
                } else {
                    this.translationDescriptionErrorKey = 'profile.description-min-error';
                }
            } else {
                this.enableSubmitButton.description = false;
                let body = JSON.stringify({
                    description: this.description
                });

                this.loaderService.show();

                this.apiService.post('/ws/profile/description', body)
                    .subscribe(data => {
                        this.enableSubmitButton.description = true;
                        if (data.added === true) {
                            CacheService.remove(CacheService.LOGGED_USER);
                            this.apiService.user().subscribe(
                                user => {
                                    if (user instanceof LoggedUser) {
                                        this.user = user;
                                        this.loaderService.hide();
                                        this.descriptionStatusType = 'success';
                                        this.translationDescriptionKey = 'profile.description-pending';
                                    }
                                },
                                error => {},
                                () => {
                                    this.loaderService.hide();
                                }
                            );
                        }
                    }
                );
            }
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./src/app/components/profile/edit-profile/edit-profile.component.ts